import React from 'react';
import { Copy } from '../../dashboard/elements/LayoutElements';

const message = `
    Hi, this is the developer menu.  If you found this by exploring the app, this menu is used to help debug problems and develop the
    application.  We have left it accessible primarily in case we need it when debugging and customer problems, but also because you
    might find it interesting and you can't do any harm with it.
`;

export const DeveloperWelcomeInfo = () =>
    <Copy>{message}</Copy>;
